exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard .page-header{text-align:center;display:flex;align-items:center}.dashboard .page-header #page-title{flex:1 0 auto}.dashboard .page-section{transition:all .6s}", ""]);

